import Constants from './constants';

const carData = {
    model: {
        defaultModels: [Constants().MODEL_S, Constants().MODEL_X, Constants().MODEL_3],
        US: [Constants().MODEL_S, Constants().MODEL_X, Constants().MODEL_3, Constants().MODEL_Y],
        CA: [Constants().MODEL_S, Constants().MODEL_X, Constants().MODEL_3, Constants().MODEL_Y]
    },
    name: {
        [Constants().MODEL_S]: Constants().MODEL_S_LBL,
        [Constants().MODEL_X]: Constants().MODEL_X_LBL,
        [Constants().MODEL_3]: Constants().MODEL_3_LBL,
        [Constants().MODEL_Y]: Constants().MODEL_Y_LBL
    }
}

export default carData;
